import React, {useEffect, useState} from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { clsx } from "clsx";
import ContentArea from "../ContentArea";
import ButtonBlock from "../ButtonBlock";
import MediaArea from "../MediaArea";

const TwoColumnGridLayout = ({
  settings,
  blocks,
  props,
}) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { globals } = props;

  const layout = isMobile ? settings.layout_type_mobile : settings.layout_type;
  const imageWidth = isMobile ? settings.width_mobile : settings.width;
  const description = settings.content || '';
  const reverselayout = settings.reverselayout || '';
  const classes = settings.classes || '';

  return (
    <section className={`w-full ${classes} twi-${layout}`}>
      <div
        className={`twi-${layout}__container lg:h-[${settings.container_height}px] overflow-hidden relative`}
      >
        <div
          className={`twi-${layout}__content ${clsx({
            "flex-col": isMobile,
            "flex-col-reverse": isMobile && settings.reverse_layout_mobile,
            "flex-row-reverse": reverselayout && settings.reverse_layout,
          })}`}
        >
          <div
            className="flex flex-col justify-center space-y-4 lg:basis-1/2"
            style={{ flexBasis: imageWidth + "%" }}
          >
            <div className={`flex h-full w-full`}>
              <MediaArea globals={globals} settings={settings} isMobile={isMobile} />
            </div>
          </div>
          <div
            className="twi-container"
            style={{ flexBasis: `calc(${100 - parseFloat(imageWidth)}%)` }}
          >
            <div
              className={`twi-content h-full justify-${settings.content_position_desktop}`}
            >
              <div
                className={`w-full flex flex-col items-${settings.content_alignment_mobile} lg:items-${settings.content_alignment_desktop}`}
              >
                <ContentArea settings={settings} description={description} isMobile={isMobile} />
                <ButtonBlock blocks={blocks} settings={settings} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoColumnGridLayout;
